import { render } from "./selectCliente.vue?vue&type=template&id=7154f0cd"
import script from "./selectCliente.vue?vue&type=script&lang=ts"
export * from "./selectCliente.vue?vue&type=script&lang=ts"
script.render = render

export default script